import isString from 'lodash/isString';
import { COMPANION_AD_CLICKED, COMPANION_AD_RENDER_ERROR, COMPANION_INVALID_CLICK_HANDLER, } from '../../../logging/constants';
import logger from '../../../logging/logger';
import reporter from '../../reporter';
import injectDynamicAdContent from './injectDynamicAdContent';
import injectStaticAdContent from './injectStaticAdContent';
export function isDynamicAdContent(content) {
    if (!(content && isString(content))) {
        return false;
    }
    const scriptTagIndex = content.indexOf('<script>');
    return scriptTagIndex >= 0;
}
export default function injectCompanionAd(options) {
    const { adSlot, adContent, adContainer, adWidth, adHeight } = options;
    function reportClick() {
        reporter.click(adSlot);
        logger.info({
            message: COMPANION_AD_CLICKED,
            data: reporter.getParameters(adSlot),
        });
    }
    function reportError() {
        logger.error({
            message: COMPANION_INVALID_CLICK_HANDLER,
            data: reporter.getParameters(adSlot),
        });
    }
    try {
        const element = isDynamicAdContent(adContent)
            ? injectDynamicAdContent(adContainer, adContent, adWidth, adHeight)
            : injectStaticAdContent(adContainer, adContent);
        if (!element) {
            reportError();
            return;
        }
        element.addEventListener('click', reportClick);
    }
    catch (ex) {
        logger.error({
            message: COMPANION_AD_RENDER_ERROR,
            error: ex,
            data: reporter.getParameters(adSlot),
        });
    }
}
